import React from 'react';
import { Grid } from 'vindi-ds-components';
import styles from './styles';

function HomeContainer({ children }) {
  return (
    <Grid container spacing={4} style={styles.homeContainer}>
      {children}
    </Grid>
  );
}

export default HomeContainer;
